import(/* webpackMode: "eager" */ "/home/runner/work/SOFAR/SOFAR/app/privacy-policy/page.js");
